// returns false if a value has invalid currency formatting (e.g., "10,00", "20.000", "30.00.00", "40.00,200")
// or if it doesn't contain any number (e.g., "apple", "")

const isValidAmount = (value) => {
  const sanitized = value.replaceAll(/[^0-9.,]/g, '')
  if (!sanitized) return false
  const currencyParts = sanitized.split('.')
  // If a decimal point exists, ensure that it only occurs at the end of the string and is followed by 1 or 2 digits
  if (
    currencyParts.length > 2 ||
    (currencyParts.length === 2 && !/^[0-9]{1,2}$/.test(currencyParts[1]))
  )
    return false
  // Check the value provided for proper separation (i.e., ignore the decimal)
  const [first, ...rest] = currencyParts[0].split(',')
  if (rest.length === 0) return true
  return first.length <= 3 && rest.every((v) => v.length === 3)
}

export default isValidAmount
